import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
const OBJECT_ID_JSON_KEY='o';
const NODE_IDS_JSON_KEY='n';
export default class ObjectIdNodeIdsMappings{
	constructor(mapObjectIdToNodeIds){
		this.getNodeIdsForObjectId= this.getNodeIdsForObjectId.bind(this);
		this.getNodeIdsForObjectIds= this.getNodeIdsForObjectIds.bind(this);
		this._mapObjectIdToNodeIds= mapObjectIdToNodeIds;
	}
	get allNodeIds(){
		return Array.from(this._mapObjectIdToNodeIds.keys());
	}
	getNodeIdsForObjectId(objectId){
		return this._mapObjectIdToNodeIds.get(objectId);
	}
	getNodeIdsForObjectIds(objectIds){
		let nodeIds =[];
		for(var objectId of objectIds){
			const nodeIdsForObjectId = this.getNodeIdsForObjectId(objectId);
			if(!nodeIdsForObjectId)continue;
			nodeIds=nodeIds.concat(nodeIdsForObjectId);
		}
		return nodeIds;
	}
	static fromJSON(jArray){
		const mapObjectIdToNodeIds = new Map();
		jArray.forEach(entry=>{
			mapObjectIdToNodeIds.set(entry[OBJECT_ID_JSON_KEY], entry[NODE_IDS_JSON_KEY]);
		});
		return new ObjectIdNodeIdsMappings(mapObjectIdToNodeIds);
	}
}